var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step" },
    [
      _c("h2", [_vm._v("When will camp run?")]),
      _vm._v(" "),
      _c("day-picker", {
        staticClass: "day-picker w-100",
        attrs: { label: "Days", height: "48px" },
        model: {
          value: _vm.weekDays,
          callback: function($$v) {
            _vm.weekDays = $$v
          },
          expression: "weekDays"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        _vm.formValid && !_vm.selectedMoreThenOneDay
          ? _c("div", { staticClass: "error" }, [
              _vm._v("You have to enter at least one day")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  required: true,
                  "current-future-date": !_vm.$route.params.id
                },
                expression:
                  "{required: true, 'current-future-date': !$route.params.id}"
              }
            ],
            attrs: { label: "Start Date", id: "start-date" },
            model: {
              value: _vm.campStartDate,
              callback: function($$v) {
                _vm.campStartDate = $$v
              },
              expression: "campStartDate"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "delimetr" }, [_vm._v("-")]),
          _vm._v(" "),
          _c("date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true, "future-date": !_vm.$route.params.id },
                expression: "{required: true, 'future-date': !$route.params.id}"
              }
            ],
            attrs: { label: "End Date", id: "end-date" },
            model: {
              value: _vm.campEndDate,
              callback: function($$v) {
                _vm.campEndDate = $$v
              },
              expression: "campEndDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        (!_vm.$route.params.id || _vm.isCampFormDraft) &&
        _vm.campStartDate &&
        _vm.currentOrFutureDate(_vm.campStartDate)
          ? _c("div", { staticClass: "error" }, [
              _vm._v(
                "\n                Should be current or future date\n            "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        _vm.campEndDateError
          ? _c("div", { staticClass: "error right-error" }, [
              _vm._v(_vm._s(_vm.campEndDateError))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("date-picker", {
        staticClass: "no-class-dates",
        attrs: {
          label: "No camp dates",
          id: "no-camp-dates",
          info: "Enter dates that camp will not meet. e.g. holidays",
          "chip-width": 115,
          "multiple-select": true
        },
        model: {
          value: _vm.noCampDates,
          callback: function($$v) {
            _vm.noCampDates = $$v
          },
          expression: "noCampDates"
        }
      }),
      _vm._v(" "),
      _c("h2", [_vm._v("When can parents register?")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("date-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    required: true,
                    "current-future-date": !_vm.$route.params.id
                  },
                  expression:
                    "{required: true, 'current-future-date': !$route.params.id}"
                }
              ],
              staticClass: "sign-up-start-date",
              attrs: {
                label: "Registration Opens",
                id: "sign-up-start-date",
                info: "Select when registration opens for this camp"
              },
              model: {
                value: _vm.signUpBeginsDate,
                callback: function($$v) {
                  _vm.signUpBeginsDate = $$v
                },
                expression: "signUpBeginsDate"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("time-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "mt-20",
              attrs: { id: "sign-up-start-time" },
              model: {
                value: _vm.signUpBeginsTime,
                callback: function($$v) {
                  _vm.signUpBeginsTime = $$v
                },
                expression: "signUpBeginsTime"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        (!_vm.$route.params.id || _vm.isCampFormDraft) &&
        _vm.signUpBeginsDate &&
        _vm.currentOrFutureDate(_vm.signUpBeginsDate)
          ? _c("div", { staticClass: "error" }, [
              _vm._v("Should be current or future date")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("date-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    required: true,
                    "future-date": !_vm.$route.params.id
                  },
                  expression:
                    "{required: true, 'future-date': !$route.params.id}"
                }
              ],
              staticClass: "sign-up-end-date",
              attrs: {
                id: "sign-up-end-date",
                label: "Registration Deadline",
                info: "Enter registration cutoff date and time"
              },
              model: {
                value: _vm.signUpEndsDate,
                callback: function($$v) {
                  _vm.signUpEndsDate = $$v
                },
                expression: "signUpEndsDate"
              }
            }),
            _vm._v(" "),
            (!_vm.$route.params.id || _vm.isCampFormDraft) &&
            _vm.signUpEndsDate &&
            _vm.futureDate(_vm.signUpEndsDate)
              ? _c(
                  "div",
                  { staticClass: "error registration-deadline-error" },
                  [_vm._v("Should be future date")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.signUpBeginsDate &&
            _vm.signUpEndsDate &&
            !_vm.signUpEndsValid &&
            _vm.formValid
              ? _c(
                  "div",
                  { staticClass: "error registration-deadline-error" },
                  [_vm._v("The end date should be after start date")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("time-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "mt-20",
              attrs: { id: "sign-up-end-time" },
              model: {
                value: _vm.signUpEndsTime,
                callback: function($$v) {
                  _vm.signUpEndsTime = $$v
                },
                expression: "signUpEndsTime"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        _vm.signUpEndsDate &&
        _vm.signUpBeginsDate &&
        !_vm.signUpEndsValid &&
        _vm.formValid
          ? _c("div", { staticClass: "error" }, [
              _vm._v("The end date should be after start date")
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43925212", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43925212","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/Step3.vue
// module id = null
// module chunks = 